export const getDescriptionParts = (
  description?: string | null
): (string | null)[] => {
  return description
    ? (
        description.match(/^(.*)<em>(.*?)<\/em>(.*)$/) || [
          null,
          description,
          null,
          '',
        ]
      ).slice(1)
    : [null, null, null];
};
